import { SelectOption } from '@/components/Form/src/types'
import { statusEnums } from './statusEnum'

const FellowProfileStatus: SelectOption[] = [
  {
    label: 'Active',
    value: statusEnums.FellowProfileStatus.Active
  },
  {
    label: 'Deceased',
    value: statusEnums.FellowProfileStatus.Deceased
  },
  {
    label: 'Terminated',
    value: statusEnums.FellowProfileStatus.Terminated
  },
  {
    label: 'Withdrawn',
    value: statusEnums.FellowProfileStatus.Withdrawn
  }
]

const trainingAppointmentStatus: SelectOption[] = [
  {
    label: 'Saved',
    value: statusEnums.trainingAppointmentStatus.Saved
  },
  {
    label: 'Released to Trainee',
    value: statusEnums.trainingAppointmentStatus.ReleasedTrainee
  },
  {
    label: 'Submitted',
    value: statusEnums.trainingAppointmentStatus.Submitted
  },
  {
    label: 'ReSubmitted by Trainee',
    value: statusEnums.trainingAppointmentStatus.ReSubmitted
  },
  {
    label: 'Endorsed by COS',
    value: statusEnums.trainingAppointmentStatus.EndorsedCos
  },
  {
    label: 'Approved by Admin',
    value: statusEnums.trainingAppointmentStatus.ApprovedAdmin
  },
  {
    label: 'Rejected by Admin',
    value: statusEnums.trainingAppointmentStatus.RejectedAdmin
  }
]

const LockStatus: SelectOption[] = [
  {
    label: 'Unlock',
    value: statusEnums.LockStatus.Unlock
  },
  {
    label: 'Locked',
    value: statusEnums.LockStatus.Locked
  }
]
const MasterTableStatus: any[] = [
  {
    label: 'Active',
    value: statusEnums.MasterTableStatus.Active
  },
  {
    label: 'Inactive',
    value: statusEnums.MasterTableStatus.Inactive
  }
]
const UserStatus: any[] = [
  {
    label: 'Active',
    value: statusEnums.UserStatus.Active
  },
  {
    label: 'Inactive',
    value: statusEnums.UserStatus.Inactive
  }
]
const TrainingCentre: SelectOption[] = [
  {
    label: 'No',
    value: statusEnums.TrainingCentre.no
  },
  {
    label: 'Yes',
    value: statusEnums.TrainingCentre.yes
  }
]
export const statusOption = {
  FellowProfileStatus,
  LockStatus,
  MasterTableStatus,
  TrainingCentre,
  UserStatus,
  trainingAppointmentStatus
}
